export default {"src":"/_next/static/media/visa-logo.730e2402.svg","height":325,"width":1000,"blurWidth":0,"blurHeight":0};